import React from 'react';
import { MegaMenuSectionTitle } from './MegaMenuSectionTitle';
import { MegaMenuLink } from './MegaMenuLink';
import { MegaMenuCTA } from 'src/components/Header/components/MegaMenu/MegaMenuCTA';
import { useMegaMenu } from 'src/components/Header/components/MegaMenu/useMegaMenu';

export const MegaMenuLatestPage = ({ latestFeaturedPost }: {latestFeaturedPost: {
  id: string,
  title: string,
  slug: string,
  tags: string[],
  image: string,
},}) => {
  const { megaMenuState } = useMegaMenu();
  let to = null;
  if(latestFeaturedPost && latestFeaturedPost.tags) {
    to = latestFeaturedPost.tags.includes('events') ? `/events/${latestFeaturedPost.slug}` : latestFeaturedPost.tags.includes('news') ? `/news/${latestFeaturedPost.slug}` : latestFeaturedPost.tags.includes('blogs') ? `/riac-blog/${latestFeaturedPost.slug}` : latestFeaturedPost.tags.includes('videos') ? `/video/${latestFeaturedPost.slug}` : null;
  }
  return (
    <div>
      <div className='grid grid-cols-2 xl:grid-cols-3 gap-x-10'>
        <div className='xl:col-span-2 grid grid-cols-1 xl:grid-cols-2 gap-x-10 gap-y-6 py-5'>
          <div className='flex flex-col gap-3'>
            <MegaMenuSectionTitle title='Latest' to='/news-and-events'/>
            <div className='flex flex-col gap-4'>
              <MegaMenuLink
                onPress={() => megaMenuState.close()}
                label='News' to='/news-and-events#news' description='The latest press releases, auction results, announcements, and more.'/>
              <MegaMenuLink
                onPress={() => megaMenuState.close()}
                label='Blogs' to='/news-and-events#blogs' description='In-depth articles on rare firearm models, historic icons, gun values, collecting, and more.'/>
            </div>
          </div>
          <div className='flex flex-col gap-3'>
            <div className='flex flex-col gap-4 -mt-1 xl:mt-0 xl:pt-10'>
              <MegaMenuLink
                onPress={() => megaMenuState.close()}
                label='Videos' to='/news-and-events#videos' description='Watch the latest videos examining many of the finest firearms in collecting.'/>
              <MegaMenuLink
                onPress={() => megaMenuState.close()}
                label='Events' to='/news-and-events#events' description='Find us around the country at these firearm related events.'/>
            </div>
          </div>
        </div>
        <div className='w-full'>
          { to
          && <MegaMenuCTA
            onPress={() => megaMenuState.close()}
            to={to} buttonLabel='Read Now' src={latestFeaturedPost?.image || 'https://placehold.co/405x606'} id='mega-menu-latest-cta'/>
          }
        </div>
      </div>
    </div>
  );
};
